export const getFilteredStatus = (activeFilters: string[], subscriptions) =>
  subscriptions.filter((subscription) => activeFilters.includes(subscription.health?.status));
